import type { FunctionComponent } from 'react'
import { useMemo } from 'react'
import { SelectField } from '@retailer-platform/shared-components/src/tds'
import { useSearchStoreGroups } from '../../../legacy/sections/store-groups/graphql/search.hooks'

interface StoreGroupSelectProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  isDisabled?: boolean
}

export const StoreGroupSelect: FunctionComponent<StoreGroupSelectProps> = ({
  value,
  onChange,
  placeholder,
  isDisabled = false,
}) => {
  const { storeGroups, loading } = useSearchStoreGroups()

  const storeGroupOptions = useMemo(
    () =>
      storeGroups.map(storeGroup => ({
        label: `${storeGroup.name} (${storeGroup.retailerLocationIds.length})`,
        value: storeGroup.id,
      })),
    [storeGroups]
  )

  return (
    <SelectField
      options={storeGroupOptions}
      placeholder={placeholder}
      value={value || null}
      onChange={(newValue?: string) => onChange(newValue || '')}
      isLoading={loading}
      searchable
      disabled={isDisabled}
    />
  )
}
